module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABBNAAAQTQFnjAHgAAABQklEQVRYhe3Ywa3CMAwG4B/07rABI/BGeCOwAXDytaNw9Yk3AiMwAozABjBBUVEqRU1jJw6Vesh/bN3qo0ntikXbtphTlrPSVFBCKkhLBWn5Uc6DiA4ATgD+mPkWFCghojWAK4AbMx/kauUJOcwZwKq7KRH9BkVCPMwWwJ6I/uPVCaBBslADTB/1WhHEzN0vOnqHklARzL1b9qA4B2RBSRhmfgYX5IJyUKWYZFAK6huYLtmfH96b1+cFYOdaQxHGBIqghjFhYO3UI8vnx4wxg1wuAB7BUaCxYswgbwNvgpPAJdYSJgFF3ib/SY22hElAEczdjYRoS5gEJGA+G3hko5tQSaDUpvcNlArK7cClKBFkHQclKBFUMg5iqKAwE9Q4RBZGQDVB0SDqLHPLdirpwG729UAx9c8GLRWkpYK0zAsE4A184b3zzcTdiQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_clear.png
// module id = p0Ah
// module chunks = 4